import { useEffect, useState } from "react";
import { useRouter } from "next/router";

export default function useMobileSideBar() {
  const { pathname } = useRouter();
  const [isMobileSideBarOpen, setIsMobileSideBarOpen] = useState(false);

  const handleShowOrHideSidebar = () => {
    setIsMobileSideBarOpen((previous) => !previous);
  };

  useEffect(() => {
    setIsMobileSideBarOpen(false);
  }, [pathname]);

  return { isMobileSideBarOpen, handleShowOrHideSidebar };
}
